import type { CircularProgressWidgetProps } from './CircularProgressWidget'

type RenderSecondaryTextProps = Pick<CircularProgressWidgetProps, 'count' | 'total'>
export const renderSecondaryText = ({
    count,
    total,
}: RenderSecondaryTextProps): `${number} of ${number}` | 'No data' =>
    typeof count === 'number' &&
    typeof total === 'number' &&
    Number.isInteger(count) &&
    Number.isInteger(total) &&
    count >= 0 &&
    total > 0
        ? `${count} of ${total}`
        : `No data`

type RenderPercentageProps = Pick<CircularProgressWidgetProps, 'count' | 'total'>
export const renderPercentage = ({ count, total }: RenderPercentageProps): number =>
    typeof count === 'number' &&
    typeof total === 'number' &&
    Number.isInteger(count) &&
    Number.isInteger(total) &&
    count >= 0 &&
    total > 0
        ? (count / total) * 100
        : NaN

type RenderCircleTextProps = Pick<CircularProgressWidgetProps, 'count' | 'total'>
type RenderCircleTextReturn = `${number}%` | '<1%' | '>99%' | '>100%' | '--%'

export const renderCircleText = ({ count, total }: RenderCircleTextProps): RenderCircleTextReturn => {
    if (
        // count == null ||
        // total == null ||
        // Number.isNaN(count) ||
        // Number.isNaN(total)

        count == null ||
        total == null ||
        !Number.isInteger(count) ||
        !Number.isInteger(total)
    ) {
        return '--%'
    }

    const percentage = renderPercentage({ count, total })

    if (Number.isNaN(percentage)) {
        return '--%'
    }

    if (percentage === 0) {
        return '0%'
    }

    if (percentage < 1) {
        return '<1%'
    }

    if (percentage > 100) {
        return '>100%'
    }

    if (percentage === 100) {
        return '100%'
    }

    if (percentage > 99) {
        return '>99%'
    }

    const roundedPct = Math.round(percentage)
    return `${roundedPct}%`
}
